<template>
  <div class="mb-5">
    <div class="pdf-icon">
      <a @click="createPdf">
        <img src="@/assets/images/pdf.png" alt="PDF" height="32" />
      </a>
    </div>
    <div id="x-report" class="xz-report">
      <TransactionsReportHeader :fromDate="fromDate" :toDate="toDate" :company="company" />
      <TransactionsReportSalesPayments :transactionsReport="transactionsReport" />
      <TransactionsReportRefund :transactionsReport="transactionsReport" />
    </div>
  </div>
</template>

<script>
  import TransactionsReportSalesPayments from "@/components/report/transactions/TransactionsReportSalesPayments";
  import TransactionsReportHeader from "@/components/report/transactions/TransactionsReportHeader";
  import ReportPdfBuilder from "@/util/ReportPdfBuilder";
  import TransactionsReportRefund from "@/components/report/transactions/TransactionsReportRefund.vue";

  export default {
    components: {TransactionsReportHeader, TransactionsReportSalesPayments, TransactionsReportRefund},
    props: {
      fromDate: Date,
      toDate: Date,
      transactionsReport: Object,
      company: Object,
    },
    methods: {
      createPdf() {
        ReportPdfBuilder.buildTransactionsReportPdf(this.transactionsReport, this.company, this.fromDate, this.toDate);
      }
    }
  }
</script>
